import styled from '@emotion/styled';

export const AdminCountriesContentWrapper = styled('div', { label: 'AdminCountriesContentWrapper' })`
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 0%;
`;

export const AdminCountriesContentLhs = styled('nav', { label: 'AdminCountriesContentLhs' })`
    display: flex;
    flex-flow: column nowrap;
    flex: 0 0 25%;
    height: calc(100vh - 104px);
    width: 25%;
`;

export const AdminCountriesContent = styled('div', { label: 'AdminCountriesContent' })`
    flex: 1 1 0%;
    height: calc(100vh - 104px);
    margin-left: 5px;
    overflow: hidden auto;
    width: auto;
`;
